import Vue from 'vue'
import VueRouter from 'vue-router'

import ReservationSection from '../views/ReservationSection.vue'
import RetourSection from '../views/RetourSection.vue'
import AdminSection from '../views/AdminSection.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: ReservationSection
  },
  {
    path: '/gerer',
    component: AdminSection
  },
  {
    path: '/about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutSection.vue')
  },
  {
    path: '/retour/:ok',
    component: RetourSection
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
